import { render, staticRenderFns } from "./manual-allocation.vue?vue&type=template&id=bc7fb564&"
import script from "./js/manual-allocation.js?vue&type=script&lang=js&"
export * from "./js/manual-allocation.js?vue&type=script&lang=js&"
import style0 from "./manual-allocation.vue?vue&type=style&index=0&id=bc7fb564&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports